import React from 'react';
import { themr } from 'react-css-themr';

import AvatarModal from './AvatarModal';
import baseNetworkPickerTheme from './NetworkPicker.scss';
import { CdnContext } from '../../context';

class NetworkPicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props,
            people: [],
        };
    }

    componentWillMount() {
        this.setInitialAnswer();
    }

    componentWillUnmount() {
        const {
            people, part, section, setAnswer,
        } = this.state;

        setAnswer({
            part,
            section,
            answer: people,
        });
    }

    setInitialAnswer() {
        const { answer, onStateChange } = this.props;

        if (this.state.people.length === 0 && answer && answer.length > 0) {
            this.setState({
                people: answer,
            });
            onStateChange(true);
        }
    }

    getPersonComponent(person, index, theme) {
        return (
            <CdnContext.Consumer key={index}>
                {cdn => (
                    <div className={theme.person}>
                        <img
                            src={`${cdn}assets/images/avatars/${
                                person.avatar.filename
                            }`}
                            alt={person.avatar.slug}
                        />
                        <span onClick={() => this.handleDeleteAvatar(index)}>
                            X
                        </span>
                        <label htmlFor={person.name}>naam:</label>
                        <input
                            type="text"
                            autoFocus // eslint-disable-line
                            name={person.name}
                            value={person.name}
                            onChange={(e) => {
                                this.handleNameChange(e, index);
                            }}
                        />
                    </div>
                )}
            </CdnContext.Consumer>
        );
    }

    validState() {
        const { people } = this.state;

        if (people.length === 0) {
            return false;
        }

        for (let i = 0; i < people.length; i += 1) {
            if (people[i].name.length === 0) {
                return false;
            }
        }

        return true;
    }

    closeModal = () => {
        this.setState({
            modalOpen: false,
        });
    };

    handleNameChange(evt, index) {
        const { people } = this.state;
        const { onStateChange } = this.props;

        people[index].name = evt.target.value;

        this.setState({
            people,
        });

        onStateChange(this.validState());
    }

    handleAddPerson = () => {
        this.setState({
            modalOpen: true,
        });
    };

    handleAvatarClick = (avatar) => {
        const { people } = this.state;
        people.push({
            name: '',
            avatar,
        });

        this.setState({
            people,
            modalOpen: false,
        });
    };

    handleDeleteAvatar = (index) => {
        const { people } = this.state;
        const newPeople = [...people];

        newPeople.splice(index, 1);
        this.setState({
            people: newPeople,
        });
    }

    render() {
        const { people, modalOpen } = this.state;
        const { theme, header } = this.props;

        return (
            <div className={theme.root}>
                <h2 className="question-heading">{header.title}</h2>
                <div className="question-description">
                    <p>{header.description}</p>
                </div>

                <div className={theme.people}>
                    {people.map((p, index) =>
                        this.getPersonComponent(p, index, theme))}
                </div>
                <button
                    className={theme.addPerson}
                    onClick={this.handleAddPerson}
                >
                    <span>+</span>{' '}
                    {people.length === 0
                        ? 'Voeg iemand toe'
                        : 'Voeg nog iemand toe'}
                </button>

                <AvatarModal
                    onClose={this.closeModal}
                    open={modalOpen}
                    onAvatarChosen={this.handleAvatarClick}
                />
            </div>
        );
    }
}

export default themr('NetworkPicker', baseNetworkPickerTheme)(NetworkPicker);



// WEBPACK FOOTER //
// ./src/components/questions/NetworkPicker.js